<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'ou' ? $tc("m.BT_OUF", 2) : $tc("m.BT_OUH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      template(v-if="details['ou'][0][8] == 4.5")
        p.mb-0 B
        p.mb-0 S
      template(v-else)
        p.mb-0 {{ $t("m.ODD_Over") }}
        p.mb-0 {{ $t("m.ODD_Under") }}
    template(v-for="(dn, i) in details['tn']")
      .match-odd-area-group(v-if="i < 2")
        template(v-if="details[betType] && details[betType][i] && details[betType][i][11] != 0 && details[betType][i][12] != 0 && details[betType][i][11] != '' && details[betType][i][12] != ''")
          OddsItem(:odds="details[betType][i]" idx=12 :typ="oddsType" dataType="1" :mode="betType" label="over" :count="i" :details="details" homeAway="1")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i] && details[betType][i][11] != 0 && details[betType][i][12] != 0 && details[betType][i][11] != '' && details[betType][i][12] != ''")
          OddsItem(:odds="details[betType][i]" idx=11 :typ="oddsType" dataType="1" :mode="betType" label="under" :count="i" :details="details" homeAway="2")
        template(v-else)
          OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    },
  }
};
</script>